<template>
  <div>
    <!--
      Bewusst klassisches Bootstrap/jQuery-Modal statt b-modal: die Personensuche (SingleSelectPerson → gpSucheModal)
      ist selbst ein jQuery-Modal und ist innerhalb eines b-modal nicht klickbar (Backdrop liegt darüber).
      Muster wie NotizModal.
    -->
    <div :id="id" class="modal fade">
      <div class="modal-dialog modal-xl">
        <div class="modal-content" v-if="shown">
          <div class="modal-header">
            <modal-close-button-new @confirmed="closeModal" />
            <h4 class="modal-title">{{ $t("global.roomreservation") }}</h4>
          </div>
          <div class="modal-body">
            <zimmerreservation-formular
              ref="formular"
              :formId="id + '-formular'"
              :veranstaltung="veranstaltung"
              :lehrgang="lehrgang"
              :module="module"
              :hotelkontingente="hotelkontingente"
              :reservationstypen="reservationstypen"
              :editable="editable"
              :vorgabeKontingent="vorgabeKontingent"
              @valid="(val) => (valid = val)"
            />
          </div>
          <div class="modal-footer">
            <button class="btn btn-default mr-2" @click="closeModal">
              {{ $t("global.cancel") }}
            </button>
            <button v-if="editable" class="btn btn-primary" :disabled="!valid || saving" @click="speichern">
              {{ $t("global.save") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ModalCloseButtonNew from "@/components/global/ModalCloseButtonNew";
import ZimmerreservationFormular from "@/components/Zimmer/ZimmerreservationFormular";
import { apiErrorToAlert } from "@/utils/Errorhandler";

/**
 * Modal um das ZimmerreservationFormular. Öffnen über ref: this.$refs.<ref>.oeffnen(reservationId | null)
 */
export default {
  name: "ZimmerreservationModal",
  components: { ModalCloseButtonNew, ZimmerreservationFormular },
  props: {
    id: { type: String, default: "zimmerreservation-modal" },
    veranstaltung: { type: String, required: false },
    lehrgang: { type: String, required: false },
    module: { type: Array, default: () => [] },
    hotelkontingente: { type: Array, default: () => [] },
    reservationstypen: { type: Array, default: () => [] },
    editable: { type: Boolean, required: true },
    vorgabeKontingent: { type: Object, required: false },
  },
  data() {
    return {
      shown: false,
      valid: false,
      saving: false,
    };
  },
  methods: {
    oeffnen(reservationId) {
      this.shown = true;
      // Formular wird erst mit shown gerendert → nach dem Rendern initialisieren
      this.$nextTick(() => {
        this.$refs.formular.initialisieren(reservationId || null);
        $("#" + this.id).modal({ backdrop: "static", keyboard: false });
      });
    },
    speichern() {
      this.saving = true;
      this.$refs.formular
        .speichern()
        .then(() => {
          this.$emit("saved");
          this.closeModal();
        })
        .catch((e) => this.$notify(apiErrorToAlert(e)))
        .finally(() => {
          this.saving = false;
        });
    },
    closeModal() {
      $("#" + this.id).modal("hide");
      this.shown = false;
    },
  },
};
</script>
